import type { RootState } from '@/redux-store';
import { store } from '@/redux-store';
import { Role } from '../role';

export class TechnicianRole extends Role {
    public queryById(): null | string {
        const state = store.getState() as RootState;

        const userId = state.auth.userInformation?.id;

        return userId || null;
    }

    public getInformationHomeRoute() {
        return {
            routeKey: this.routeManager.STAFF_DETAIL,
            params: {
                id: this.queryById(),
                breadcrumb: [{ routeKey: this.routeManager.HOME }],
            },
        };
    }

    public canLeaveReview(): boolean {
        return true;
    }

    public canUpdateSignature(): boolean {
        return true;
    }

    public defaultRoute(): string {
        return this.routeManager.HOME;
    }
}
